export class GeneralDashboardService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
    }
    async getGenders() {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/contacts?$groupby=gender',
        });
    }
    async getAverageResponseTime() {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: '/message-statistic/responseTime',
        });
    }
    async getWordCount(startDate, endDate) {
        return this.MessagingHubService.sendCommand({
            method: 'get',
            uri: `/message-statistic/word-count?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&$skip=0&$take=100`,
        });
    }
}
GeneralDashboardService.$inject = ['MessagingHubService'];
